import { render, staticRenderFns } from "./inbound-connection-rate-widget.vue?vue&type=template&id=bd56fe3e"
import script from "./inbound-connection-rate-widget.vue?vue&type=script&lang=js"
export * from "./inbound-connection-rate-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports